import {getPrivateAxios} from '../../libs';
import {Team} from './types';

export interface UpdateTeamDto {
  id: string;
  name: string;
}

export const fetchTeamUpdate = async (updateTeamDto: UpdateTeamDto) => {
  const {data} = await getPrivateAxios().patch<Team>(`/teams/${updateTeamDto.id}`, updateTeamDto);
  return data;
};
